import { ACTIONS_KEYS, MUTATIONS_KEYS } from '../../store';
import { createWires } from '../wiring.util';
import { WIRE_FACTORY } from './wires.factory';

export const NO_RESULTS_WIRES = createWires({
  getFallbackFiltersResults: WIRE_FACTORY.dispatchAction(ACTIONS_KEYS.noResults.getFallbackFiltersResults),
  clearFallbackFiltersResults: WIRE_FACTORY.commitMutation(MUTATIONS_KEYS.noResults.clearFallbackFiltersResults)
});
